export default fieldMapping => data => {
  if (typeof data !== 'object' || typeof fieldMapping !== 'object' || Array.isArray(fieldMapping)) {
    return data;
  }
  const result = {};
  Object.keys(data).forEach(key => {
    const newKey = fieldMapping[key];
    if (typeof newKey === 'string') {
      result[newKey] = data[key];
    } else {
      result[key] = data[key];
    }
  });
  return result;
};
